import { createSlice } from '@reduxjs/toolkit';

const initialStateDashboard = {
    listLoading: false,
    actionsLoading: false,
    dashboardInfo: undefined,
    success: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: initialStateDashboard,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get dashboard info
        dashboardFetched: (state, action) => {
            state.listLoading = false;
            state.dashboardInfo = action.payload.dashboardInfo;
            state.error = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.dashboardInfo = undefined;
            state.error = null;
            state.success = null;
        }
    }
});